import * as THREE from 'three';
import type { MazeDirection, MazeStageDefinition } from '../config/mazeStages';

export type MazeRobotPose = { x: number; y: number; dir: MazeDirection };

export const mazeGridToWorld = (stage: MazeStageDefinition, x: number, y: number) => ({
  x: x - ((stage.grid[0]?.length ?? 1) - 1) / 2,
  y: (stage.grid.length - 1) / 2 - y,
});

const mazeYaw = (dir: MazeDirection) => Math.PI - dir * Math.PI / 4;

export const applyMazePoseToAnchor = (
  stage: MazeStageDefinition,
  anchor: THREE.Object3D,
  root: THREE.Object3D,
  pose: MazeRobotPose,
  preserveWorldPosition: boolean,
) => {
  root.updateWorldMatrix(true, false);
  const previousWorldPosition = preserveWorldPosition
    ? root.getWorldPosition(new THREE.Vector3())
    : null;
  const world = mazeGridToWorld(stage, pose.x, pose.y);

  root.position.set(0, 0, 0);
  root.rotation.z = 0;
  anchor.position.set(world.x, world.y, 0);
  anchor.rotation.z = mazeYaw(pose.dir);
  anchor.updateWorldMatrix(true, false);

  if (previousWorldPosition) {
    root.position.copy(anchor.worldToLocal(previousWorldPosition));
  }
  root.updateWorldMatrix(true, false);
};
